import React, { useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { ShieldCheck, KeyRound } from "lucide-react";

export default function GateScreen({ onUnlock }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const res = await api.post("/auth/gate", { username, password });
      localStorage.setItem("gate_token", res.data.gate_token);
      onUnlock();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Verifikasi gagal");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 p-6">
      <div className="w-full max-w-sm" data-testid="gate-screen">
        <div className="flex flex-col items-center mb-8">
          <div className="h-14 w-14 rounded-full border border-zinc-700 flex items-center justify-center mb-4">
            <ShieldCheck className="h-7 w-7 text-zinc-300" />
          </div>
          <h1 className="text-xl font-bold text-white tracking-tight">Akses Terbatas</h1>
          <p className="text-sm text-zinc-400 mt-2 text-center">
            Aplikasi ini dilindungi. Masukkan kredensial akses untuk melanjutkan.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-testid="gate-form">
          <div>
            <Label htmlFor="gate-username" className="text-xs uppercase tracking-wider text-zinc-400">Username</Label>
            <Input
              id="gate-username" value={username} autoFocus
              onChange={(e) => setUsername(e.target.value)}
              required data-testid="gate-username-input"
              className="mt-1.5 bg-zinc-900 border-zinc-700 text-white"
              autoComplete="off"
            />
          </div>
          <div>
            <Label htmlFor="gate-password" className="text-xs uppercase tracking-wider text-zinc-400">Password</Label>
            <Input
              id="gate-password" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              required data-testid="gate-password-input"
              className="mt-1.5 bg-zinc-900 border-zinc-700 text-white"
              autoComplete="off"
            />
          </div>
          {error && (
            <div className="text-sm text-red-400" data-testid="gate-error">{error}</div>
          )}
          <Button
            type="submit" disabled={submitting}
            className="w-full bg-white text-zinc-950 hover:bg-zinc-200"
            data-testid="gate-submit-button"
          >
            <KeyRound className="h-3.5 w-3.5 mr-2" />
            {submitting ? "Memverifikasi…" : "Buka Akses"}
          </Button>
        </form>

        <div className="mt-8 text-center text-[11px] text-zinc-600 uppercase tracking-[0.2em]">
          Limit.Graph · Protected Gateway
        </div>
      </div>
    </div>
  );
}
